import React from 'react';
import './Section.css';

function RespectGuide() {
  const respectPrinciples = [
    {
      principle: 'Consent-Based Physical Contact',
      explanation: 'Never force hugs or lap-sitting. Offer your finger at cat nose level. If they nudge and rub their scent glands against your hand, they consent. If they turn away or step back, respect their decision immediately.'
    },
    {
      principle: 'Deciphering Tail & Ear Dialect',
      explanation: 'An upright tail with a soft hook indicates a friendly greeting. Rapid tail swishing or thumping signals overstimulation and annoyance. Flattened "airplane" ears indicate fear or defensive readiness.'
    },
    {
      principle: 'The Slow Blink — The Feline "I Trust You"',
      explanation: 'Direct, unblinking eye contact is perceived by cats as a predator\'s predatory stare or threat. Offer slow, relaxed blinks with softened facial muscles to communicate peace and safety.'
    },
    {
      principle: 'Understanding the Belly Trap',
      explanation: 'Rolling onto their back exposing the belly is a supreme sign of safety and trust—it is NOT always an invitation for belly rubs. Touching the abdominal region often triggers instinctive defensive clasping and scratching.'
    },
    {
      principle: 'Safe Havens & Agency',
      explanation: 'Cats thrive when they have autonomy over their personal space. Never pull a cat from underneath furniture, a carrier, or an elevated hiding box when they seek solitude.'
    },
    {
      principle: 'Zero Physical Punishment Policy',
      explanation: 'Cats do not associate physical discipline or yelling with past actions; it merely erodes trust and induces chronic stress or fear-based aggression. Use positive redirection instead.'
    }
  ];

  return (
    <section className="section-panel">
      <div className="section-header">
        <h2>Earning Feline Respect & Decoding Ethology</h2>
        <p>Cats cannot be controlled like pack animals; friendship with a feline is built on autonomy, predictability, and mutual consent.</p>
      </div>
      <div className="card-grid">
        {respectPrinciples.map((item, index) => (
          <div key={index} className="info-card border-accent">
            <h3>{item.principle}</h3>
            <p>{item.explanation}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default RespectGuide;